import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { QuickQuestion } from '../../../domain/models/quick-question.model';

@Component({
  selector: 'talk-to-your-data-welcome-panel',
  templateUrl: './welcome-panel.component.html',
  styleUrls: ['./welcome-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomePanelComponent {
  @Input() quickQuestions: readonly QuickQuestion[] = [];
  @Output() readonly suggestionSelected = new EventEmitter<QuickQuestion>();

  onSuggestionSelected(question: QuickQuestion): void {
    this.suggestionSelected.emit(question);
  }
}
